import React from 'react'
import { compose } from 'recompose'
import withDataTable, { sorts } from '../../app/components/dataTable/withDataTable'

// Components
import DataTable from '../../app/components/dataTable'

// Helpers
import { formatCurrency, formatDate } from '../../common/helpers'
import { StyledSpan } from '../../theme/Global'

const columns = [
  {
    key: 'name',
    sort: (a, b) => sorts.amount(a.jurisdiction.name, b.jurisdiction.name),
    text: 'Location',
    width: 200
  },
  {
    key: 'regionType',
    sort: (a, b) => sorts.amount(a.jurisdiction.type, b.jurisdiction.type),
    text: 'Region Type',
    width: 300
  },
  {
    key: 'effectiveDate',
    sort: (a, b) => sorts.date(a.effectiveDate, b.effectiveDate),
    text: 'Effective Date',
    width: 300
  },
  {
    key: 'wage',
    sort: (a, b) => sorts.amount(a.wage ? a.wage : 0, b.wage ? b.wage : 0),
    text: 'Wage Amount',
    width: 400
  }
]

const IncreaseScheduleRenderer = ({
  onExport,
  onFilter,
  onSort,
  recordCount,
  recordType,
  renderRow
}) => (
  <DataTable
    columns={columns}
    data={renderRow}
    defaultSort={{
      sortBy: 'effectiveDate',
      direction: 'ASC'
    }}
    onExport={onExport}
    onFilter={onFilter}
    onSort={onSort}
    recordType={recordType}
    recordCount={recordCount}
    showControls={false}
  />
)

const IncreaseScheduleComponent = compose(
  withDataTable({
    columns,
    filters: [],
    recordType: 'Wage Increases',
    renderItem: (increase) => {
      const returnData = {
        name: <StyledSpan>{ increase.jurisdiction.name }</StyledSpan>,
        regionType: <StyledSpan>{ increase.jurisdiction.type }</StyledSpan>,
        effectiveDate: <StyledSpan>{ formatDate(increase.effectiveDate) }</StyledSpan>,
        wage: increase.wage ? <StyledSpan>{ formatCurrency(increase.wage) }</StyledSpan> : <StyledSpan>Indexed</StyledSpan>
      }
      return returnData
    },
    showControls: false
  })
)(IncreaseScheduleRenderer)

export default IncreaseScheduleComponent
